// Org-level (future: user-level) preferences controlling which optional inputs
// are shown on the invoice details panel, and how the account dropdown displays.
// Mirrors the JSON stored in dbo.DisplaySettings (SettingsKey = 'invoice-panel').

export type AccountDisplayMode = 'nameOnly' | 'codeAndName';

export interface InvoiceDisplayFields {
  xeroTrackingCategories: boolean;
  classes: boolean;
  customSyncedFields: boolean;
  plannedDate: boolean;
  customerField: boolean;
}

export interface InvoiceDisplaySettings {
  fields: InvoiceDisplayFields;
  accountDisplay: AccountDisplayMode;
}

// Defaults preserve today's behaviour: the previously-always-shown fields stay
// visible, the new placeholder fields start hidden, account dropdown stays name-only.
export const DEFAULT_INVOICE_DISPLAY_SETTINGS: InvoiceDisplaySettings = {
  fields: {
    xeroTrackingCategories: true,
    classes: true,
    customSyncedFields: true,
    plannedDate: false,
    customerField: false,
  },
  accountDisplay: 'nameOnly',
};
